import React from 'react';
import type { EntryPointReferenceSubject } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { ROADMAP_PACKAGE_NAME } from '../../../../../../constants';
import type { editSprintMenuEntryPoint } from './entrypoint';
import type { OwnProps } from './types';

const EditSprintMenuAsync = ({
	entryPointReferenceSubject,
	...props
}: OwnProps & {
	entryPointReferenceSubject: EntryPointReferenceSubject<typeof editSprintMenuEntryPoint>;
}) => (
	<JiraEntryPointContainer
		entryPointReferenceSubject={entryPointReferenceSubject}
		id="async-standard-roadmap-edit-sprint-menu"
		packageName={ROADMAP_PACKAGE_NAME}
		runtimeProps={props}
		errorFallback="flag"
	/>
);

export default EditSprintMenuAsync;
